module.exports = __webpack_public_path__ + "img/0Q3B8639-42_H_Foamcore.a0a188f3.jpg";